import SocialMediaCard from "./SocialMediaCard";

export default SocialMediaCard
